import { render, staticRenderFns } from "./SeoPagination.vue?vue&type=template&id=35067284&"
import script from "./SeoPagination.vue?vue&type=script&lang=js&"
export * from "./SeoPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports